import { laptopRatio, mobileRatio, theme } from '../../theme';
import { getResponsiveSize } from '../../utils';

export const requestVideoStyle = {
  requestVideo: {
    overflow: 'hidden',
    overflowY: 'auto',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: '12px',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: getResponsiveSize(8), // 8px
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 14px 14px transparent',
    },
    '&::-webkit-scrollbar-track:horizontal': {},
    '&::-webkit-scrollbar-thumb': {
      boxShadow: `inset 0 0 14px 14px ${theme.palette.myPrimary.lightBlue40}`,
      border: 'solid 4px transparent',
      borderRadius: '14px',
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      background: theme.palette.myPrimary.darkBlue100,
      border: 'none',
      boxShadow: 'none',
    },
    '@-moz-document url-prefix()': {
      scrollbarColor: `${theme.palette.myPrimary.lightBlue20} transparent`,
      scrollbarWidth: 'thin',
    },
    '& .title-group .desc-wrapper': {
      maxHeight: 'unset',
      height: 'unset',
    },
    '& .reqest-form': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      background: theme.palette.myPrimary.lightGrey,
      borderRadius: getResponsiveSize(12),
      mx: '10%',
      mt: 8,
      py: getResponsiveSize(24),
      px: getResponsiveSize(48),
      rowGap: getResponsiveSize(18),
      '& .form-title': {
        width: '100%',
        textAlign: 'center',
        color: theme.palette.myPrimary.lightBlue100,
      },
      '& .section-title': {
        color: theme.palette.neutral.lightGrey80,
        width: '100%',
        mb: getResponsiveSize(-9),
        pl: getResponsiveSize(10),
        ...theme.palette.propVars.regularFontWeight,
      },
      '& .form-input': {
        width: '49%',
        '& .Mui-error ': {
          color: theme.palette.neutral.errorDark,
          fontSize: getResponsiveSize(13),
          px: getResponsiveSize(10),
        },
        '& .MuiFormLabel-root.Mui-disabled': {
          color: theme.palette.neutral.greyRGBA80,
        },
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: 'unset',
        },
      },
      '& .treatment-type': {
        width: '49%',
        '& .mask-box': {
          width: '100%',
          '& .mask': {
            width: '48%',
            '&.right': {
              left: `calc(50% + ${getResponsiveSize(5)})`,
            },
          },
          '& .MuiButton-root': {
            width: '49.5%',
          },
        },
      },
      '& .interactive-subject': {
        borderRadius: getResponsiveSize(12),
        background: theme.palette.myPrimary.white,
        border: `1px solid ${theme.palette.myPrimary.lightBlue100}`,
        width: '49%',
        px: getResponsiveSize(27),
        '& .MuiFormControlLabel-root': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          m: 0,
          '& .MuiTypography-root': {
            color: theme.palette.neutral.greyRGBA80,
            fontSize: getResponsiveSize(14),
            userSelect: 'none !important',
          },
        },
      },
      '& .btn-wrapper': {
        width: '100%',
        '& .action-btn': {
          width: '100%',
          '&.loading': {
            background: theme.palette.myPrimary.lightBlue50,
            '& .MuiCircularProgress-root': {
              color: theme.palette.myPrimary.lightBlue100,
              width: `${getResponsiveSize(34)} !important`,
              height: `${getResponsiveSize(34)} !important`,
              minWidth: '24px',
              minHeight: '24px',
            },
          },
        },
      },
    },
    [theme.breakpoints.media.laptop]: {
      '& .reqest-form': {
        py: getResponsiveSize(24, laptopRatio),
        px: getResponsiveSize(48, laptopRatio),
        rowGap: getResponsiveSize(12, laptopRatio),
        '& .form-title': {
          mb: 1.5,
        },
        '& .form-input': {
          width: '100%',
          '& .MuiFormControl-root': {
            height: 'auto',
          },
          '& .Mui-error ': {
            fontSize: getResponsiveSize(13, laptopRatio),
          },
        },
        '& .treatment-type': {
          width: '100%',
          '& .mask-box': {
            width: '100%',
            '& .mask': {
              width: '48%',
              '&.right': {
                left: `calc(50% + ${getResponsiveSize(7)})`,
              },
            },
            '& .MuiButton-root': {
              width: '48.5%',
            },
          },
        },
        '& .interactive-subject': {
          width: '100%',
          py: getResponsiveSize(6.25, laptopRatio),
          '& .MuiFormControlLabel-root': {
            '& .MuiTypography-root': {
              fontSize: getResponsiveSize(13, laptopRatio),
            },
          },
        },
      },
    },
    [theme.breakpoints.media.tablet]: {
      '& .reqest-form': {
        mx: 0,
      },
    },
    [theme.breakpoints.media.tableResponsive]: {
      '& .reqest-form': {
        py: getResponsiveSize(16, mobileRatio),
        px: getResponsiveSize(8, mobileRatio),
        rowGap: getResponsiveSize(12, mobileRatio),
        mt: 4,
        '& .section-title': {
          fontSize: getResponsiveSize(14, mobileRatio),
        },
        '& .form-title': {
          mb: 1.5,
          fontSize: getResponsiveSize(18, mobileRatio),
        },
        '& .form-input .Mui-error ': {
          fontSize: getResponsiveSize(13, mobileRatio),
        },
        '& .interactive-subject': {
          pl: getResponsiveSize(16, mobileRatio),
          pr: getResponsiveSize(4, mobileRatio),
          py: 0,
          height: getResponsiveSize(42, mobileRatio),
          borderRadius: getResponsiveSize(8, mobileRatio),
          '& .MuiFormControlLabel-root': {
            '& .MuiTypography-root': {
              fontSize: getResponsiveSize(13, mobileRatio),
            },
          },
        },
      },
    },
  },
};
